import React from 'react'

const InProgress = () => <div>Израда је у току</div>

export default InProgress
